import get from 'lodash/get';
import { createSelector } from 'reselect';

export const DEFAULTS = {
    applySyf: {},
    context: {},
    preferences: {},
};

const selectContext = (state) => state.context || DEFAULTS.context;

export const getApplySyf = (state) => state.applySyf || DEFAULTS.applySyf;

export const getUserState = (state) => get(state, 'account.userProfile.userState', '');

export const getApplySyfPreferences = createSelector([selectContext], (context) =>
    get(context, 'preferences.applySyf', DEFAULTS.preferences)
);
